import axios from "axios";

const apis = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_APIS,
});

export default apis;